import * as types from './actionTypes'
import * as firebaseNetwork from '../API/FirebaseManager'
import * as network from '../API/NetworkRequests'
import { zeroOutApiCall } from './apiStatusActions' 


export function setCurrentCompanySuccess(companyID, sameCompany) {
    return { type: types.SET_CURRENT_COMPANY, payload: companyID, payloadTwo: sameCompany }
}


export function getCompaniesInfoForUserSuccess(companies) {
    return { type: types.GET_COMPANIES_INFO_SUCCESS, payload: companies }
}

export function setCurrentCompanyEmpty() {
    return { type: types.SET_CURRENT_COMPANY_TO_EMPTY, payload: {} }
}

export function updateCurrentCompany(updatedCompany) {
    return { type: types.UPDATE_CURRENT_COMPANY, payload: updatedCompany }
}

export function updateCurrentCompanyShouldUseBonusLevelsSuccess(shouldUSeBonusLevels, resetBonusLevelsQuarterly) {
    return { type: types.UPDATE_CURRENT_COMPANY_SHOULD_USE_BONUS_LEVELS, payload: shouldUSeBonusLevels, payloadTwo: resetBonusLevelsQuarterly }
}









export function getCompaniesInfoForUser(companyIDs) {
    return function(dispatch, getState){
        let companyArray = []
        companyIDs.map(ID => companyArray.push(firebaseNetwork.getCompanyInfoFor(ID)))
        return Promise.all(companyArray).then(companies => {
            const companiesArray = []

            companies.forEach(companyElement => {
                if (companyElement.active) {
                    companiesArray.push(companyElement)
                }
            });

            dispatch(getCompaniesInfoForUserSuccess(companiesArray))
        }).catch(error => {
            throw error
        })
    }
}


export function setCurrentCompany(companyID) {
    return function(dispatch, getState){
        const { companies } = getState();
        dispatch(zeroOutApiCall())
        const sameCompany = companies.currentCompany ? companies.currentCompany.companyID == companyID : false
        return dispatch(setCurrentCompanySuccess(companyID, sameCompany))
    }
}


export function updateCurrentCompanyInfo(companyInfo, OnHoldReportEmailList){
    return function(dispatch, getState){
        const { companies} = getState();
        return network.updateCompanyAccount(companies.currentCompany.companyID, companyInfo, OnHoldReportEmailList).then(updatedCompany => {  
            dispatch(updateCurrentCompany(updatedCompany))
        }).catch(error => {
            throw error
        })
    }
}


export function updateCurrentCompanyShouldUseBonusLevels(shouldUseBonusLevels, resetBonusLevelsQuarterly){
    return function(dispatch, getState){
        const { companies} = getState();
        dispatch(updateCurrentCompanyShouldUseBonusLevelsSuccess(shouldUseBonusLevels, resetBonusLevelsQuarterly))
        return network.updateCompanyUseBonusLevel(companies.currentCompany.companyID, shouldUseBonusLevels, resetBonusLevelsQuarterly).then(() => {  
            
        }).catch(error => {
            throw error
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/companiesAction.js